import { FontWeight, Heading, Text } from '@lili/lili-frontend-common';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { report } from '../../../../assets/svg';
import Icon from '../../../../generic-components/Icon';
import { VIEWS_MAP } from '../../../../router/constants';
import { useStore } from '../../../../store';
import { ProfilePlanPromotion } from '../../../profile/components/ProfilePlanPromotion';
import { USERS_TYPES_STYLES } from '../../constants';

export const BasicAndProIntro = () => {
  const { t } = useTranslation('reportsEN');
  const profileType = useStore((state) => state.summary.customer.customerProfile);
  const location = useLocation();
  const isExpenses = location.pathname.replace('/', '') === VIEWS_MAP.EXPENSES;
  const reportIntroData = (() => {
    switch (location.pathname.replace('/', '')) {
      case VIEWS_MAP.STATEMENT_OF_CASH_FLOWS:
        return {
          title: t('REPORTS.UPGRADE_TITLE.CASH_FLOW'),
          titleId: 'cash-flow-basic-pro-title',
        };
      case VIEWS_MAP.PROFIT_AND_LOSS:
        return {
          title: t('REPORTS.UPGRADE_TITLE.PROFIT_AND_LOSS'),
          titleId: 'profit-loss-generate-report-title',
        };
      case VIEWS_MAP.EXPENSES:
        return {
          title: t('REPORTS.UPGRADE_TITLE.EXPENSES'),
          titleId: 'expenses-generate-report-title',
          subtitle: t('REPORTS.UPGRADE_SUBTITLE.EXPENSES'),
          subtitleId: 'expenses-generate-report-subtitle',
        };
      default:
        return { title: '', id: '', reportName: '', ctaId: '' };
    }
  })();
  return (
    <div className={USERS_TYPES_STYLES.WRAPPER}>
      <Icon className='w-[109px] h-[109px]' src={report} />
      <Heading.H5
        id={reportIntroData.titleId}
        fontWeight={FontWeight.MEDIUM}
        className='text-text-main-primary  mt-[14px]'
      >
        {reportIntroData.title}
      </Heading.H5>
      {isExpenses && (
        <Text.H10
          id={reportIntroData.subtitleId}
          fontWeight={FontWeight.REGULAR}
          className='text-text-main-tertiary mt-[4px]'
        >
          {reportIntroData.title}
        </Text.H10>
      )}
      <ProfilePlanPromotion customTitle={t('REPORTS.UPGRADE_BUTTON')} shouldAppearAsButton planType={profileType} />
    </div>
  );
};
